/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_TestsInputs */

const en_rd_fix_tests = /** @type {(inputs: Rd_Fix_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wire a real test command (npm test, pytest, go test, cargo test) — without one an agent can prove nothing.`)
};

const id_rd_fix_tests = /** @type {(inputs: Rd_Fix_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapkan perintah tes sungguhan (npm test, pytest, go test, cargo test) — tanpa itu agent tidak bisa membuktikan apa pun.`)
};

/**
* | output |
* | --- |
* | "Wire a real test command (npm test, pytest, go test, cargo test) — without one an agent can prove nothing." |
*
* @param {Rd_Fix_TestsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_tests = /** @type {((inputs?: Rd_Fix_TestsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_TestsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_tests(inputs)
	return en_rd_fix_tests(inputs)
});